import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TGetImUserSigParams,
  TGetImUserSigResponse,
  getImUserSig,
  TGetImQueryUserForbidStatusParams,
  TGetImQueryUserForbidStatusResponse,
  getImQueryUserForbidStatus,
  TPostImDeleteMsgParams,
  TPostImDeleteMsgResponse,
  postImDeleteMsg,
  TGetImUserRoleParams,
  TGetImUserRoleResponse,
  getImUserRole,
} from 'core/service/yapi/hk-web/IMTencent/api'
// IM-API
// iM接口签名
export const useGetImUserSigQuery = (
  params?: TGetImUserSigParams,
  options?: TUseQueryOptions<TGetImUserSigResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['IMTencent', 'ImUserSig', 'GET', ...Object.values(params || {})],
    queryFn: () => getImUserSig(params),
  })
}

// 查询用户封禁
export const useGetImQueryUserForbidStatusQuery = (
  params?: TGetImQueryUserForbidStatusParams,
  options?: TUseQueryOptions<TGetImQueryUserForbidStatusResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['IMTencent', 'ImQueryUserForbidStatus', 'GET', ...Object.values(params || {})],
    queryFn: () => getImQueryUserForbidStatus(params),
  })
}

// 删除聊天消息
export const usePostImDeleteMsgMutation = (
  mutationOptions?: TUseMutationOptions<TPostImDeleteMsgResponse, TPostImDeleteMsgParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['IMTencent', 'ImDeleteMsg', 'Post'],
    mutationFn: (params?: TPostImDeleteMsgParams) => postImDeleteMsg(params),
  })
}

// 查询用户角色
export const useGetImUserRoleQuery = (
  params?: TGetImUserRoleParams,
  options?: TUseQueryOptions<TGetImUserRoleResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['IMTencent', 'ImUserRole', 'GET', ...Object.values(params || {})],
    queryFn: () => getImUserRole(params),
  })
}
